// extracted by mini-css-extract-plugin
module.exports = {"deliver":"styles_deliver__GaJEt","pulse":"styles_pulse__JgFxW","jump":"styles_jump__bV3Oo","wiggle":"styles_wiggle__JrFib"};